<script>
    import { slide } from 'svelte/transition';
    import { createEventDispatcher, onMount } from 'svelte';
	const dispatch = createEventDispatcher();

    export let buttonTitle = "Next";
    export let scroll = true;
    export let lineTo = undefined;
    export let actionButton;

    let disabled = false;
    let top;
    let myCanvas;
    let frame;
    let path;
    let myId = "activate-" + Math.floor(Math.random()*100000);

    function genPathHorizVert(x1, y1, x2, y2, arcRadius, stepDist) {
        let ecx = (x2 > x1) ? x2 - arcRadius : x2 + arcRadius;
        let ecy = (y2 > y1) ? y1 + arcRadius : y1 - arcRadius;
        let arcStart = Math.PI * 1.5;
        let arcEnd = (x2 > x1) ? Math.PI * 2 : Math.PI;
        let path = [];
        path.push(`M ${x1} ${y1}`);
        let xStepN = Math.ceil(Math.abs(x2 - x1) / stepDist);
        let yStepN = Math.ceil(Math.abs(y2 - y1) / stepDist);
        let arcStepN = Math.ceil(Math.PI * 0.25 * arcRadius / stepDist);
        for (let i = 0; i < xStepN + 1; i++) {
            let curX = x1 * (1-(i/xStepN)) + (ecx * (i/xStepN));
            path.push(`L ${curX} ${y1}`);
        }
        for (let i = 0; i < arcStepN; i++) {
            let curX = ecx + Math.cos(arcStart + ((i/arcStepN) * (arcEnd - arcStart))) * arcRadius;
            let curY = ecy + Math.sin(arcStart + ((i/arcStepN) * (arcEnd - arcStart))) * arcRadius;
            path.push(`L ${curX} ${curY}`);
        }
        for (let i = 0; i < yStepN + 1; i++) {
            let curY = (ecy * (1-(i/yStepN))) + y2 * (i/yStepN);
            path.push(`L ${x2} ${curY}`);
        }
        return path;
    }

    function onResize() {

        if (lineTo) {
            let startRect = top.getBoundingClientRect();
            let targetRect = lineTo.getBoundingClientRect();

            myCanvas.width = targetRect.x - startRect.x + 10;
            myCanvas.height = startRect.y - targetRect.y + 10;
            myCanvas.style.left = `${startRect.x}px`;
            myCanvas.style.top = `${targetRect.y + window.scrollY}px`;        

            path = genPathHorizVert(
                myCanvas.width, myCanvas.height / 2,
                myCanvas.width / 2, myCanvas.height,
                20, 5);
        }
    }

    onMount(() => {

        let startTime = performance.now();
        let animDuration = 500; // milliseconds

        let ctx = myCanvas.getContext('2d');

        if (lineTo) {

            onResize();

            (function loop(now) {
                ctx.clearRect(0, 0, myCanvas.width, myCanvas.height);
                let current = Math.max(0, now - startTime);
                let i = Math.floor(current / animDuration * path.length);
                ctx.lineWidth = 2;
                ctx.lineJoin = 'round';
                ctx.strokeStyle = 'black';
                ctx.stroke(new Path2D(path.slice(0, i).join(" ")));
                frame = requestAnimationFrame(loop);
            })();

        }

        return () => {
			cancelAnimationFrame(frame);
		};

    });
    
</script>

<style>
    canvas {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }
</style>

<svelte:window on:resize={onResize}></svelte:window>

<canvas width=100 height=100 bind:this={myCanvas}></canvas>

<div class="landing-container" bind:this={top}>
    <div class="box light lev1" style="position: relative; z-index: 1;"
        transition:slide|local={{delay: 500}}
        on:introend={() => scroll && window.scrollTo({left: 0, top: document.body.scrollHeight, behavior: "smooth"})}>
        <slot name="content"></slot>
    </div>
    <div class="control-container" style="justify-content: flex-end;" transition:slide|local="{{delay: 650}}">
        <div class="light box control-tab primary-action lev1" bind:this={actionButton}>
            <button id={myId} class="action-button cyan hovery" class:disabled disabled={disabled}
            title="{buttonTitle}" on:click={() => { disabled = true; dispatch('click')}}>&nbsp;</button>
            <label for={myId} class:disabled><slot name="buttonText"></slot></label>
        </div>
    </div>
</div>